import type { FC, JSX } from 'react';
import { startTransition } from 'react';
//@ts-ignore
import { ProgressBar, ProgressBarProvider, useProgress } from 'react-transition-progress';
//@ts-ignore
import { Link as NextTransitionLink } from 'react-transition-progress/next';
import type NextLink from 'next/link';

const useTransitionProgress = () => {
  const startProgress = useProgress();

  return (callback: () => void) =>
    startTransition(() => {
      startProgress();
      callback();
    });
};

const Link: FC<Omit<Parameters<typeof NextLink>[0], 'href'> & { href?: string }> = ({
  children,
  ...rest
}): JSX.Element => {
  return (
    <NextTransitionLink {...rest} prefetch={false}>
      {children}
    </NextTransitionLink>
  );
};

export { ProgressBar, ProgressBarProvider, Link, useTransitionProgress };
